<div [ngClass]="'--'+ value" class="circularProgress">   
  <div class="circularProgress__overlay">
    {{value}}%
  </div>
</div>